import { Tag } from '@components';
import { MainComponent } from 'iconsax-react';
import type { FC } from 'react';

import { CountBadge } from './CountBadge';

type Props = {
  names: string[];
  allMarkets?: boolean;
};

export const MarketCountBadge: FC<Props> = ({ names, allMarkets }) => {
  if (allMarkets) {
    return <Tag variant='Blue' label='All markets' />;
  }
  return <CountBadge entityName='Market' entities={names} icon={MainComponent} />;
};
